module.exports = __webpack_public_path__ + "img/vn_vn.95a86b20.png";